import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * EmptyStateBox - A reusable atom component for displaying empty state messages
 * 
 * @param {Object} props
 * @param {string} props.message - Message to display when empty
 * @param {Object} props.sx - Additional styling for the outer Box
 * @param {Object} props.textSx - Additional styling for the Typography
 */
const EmptyStateBox = ({
  message = 'No data available.',
  sx = {},
  textSx = {}
}) => {
  return (
    <Box
      sx={{
        p: 2,
        textAlign: 'center',
        backgroundColor: '#f9f9f9',
        borderRadius: 0,
        ...sx
      }}
    >
      <Typography color="text.secondary" sx={textSx}>
        {message}
      </Typography>
    </Box>
  );
};

export default EmptyStateBox;
